export const LOAD_USER = 'loadUser';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const CONNECT_WEBSOCKET = 'connect_websocket';
export const DISCONNECT_WEBSOCKET = 'disconnect_websocket';
export const JOIN_ROOM = 'join_room';
export const LEAVE_ROOM = 'leave_room';
export const SEND_CURRENT_URI = 'send_current_uri';
